import React from "react";
import { isMobileOnly, isMobileSafari, isChrome } from "react-device-detect";
import { Switch } from "react-router-dom";

import { PendingComponent } from "./components/_common";
import { ThemeProvider } from "@material-ui/styles";

import Login from "./pages/Login";
import PasswordRecovery from "./pages/PasswordRecovery";
import PasswordReset from "./pages/PasswordReset";
import RootViews from "./pages/RootViews";
import CampaignDetail from "./pages/CampaignDetail/CampaignDetail";
import CampaignsByInterest from "./pages/CampaignsByInterest";
import CompanyProfile from "./pages/CompanyProfile/CompanyProfile";
import PageNotFound from "./pages/PageNotFound";

import { useTheme } from "./hooks";
import { Provider as ViewsContextProvider } from "./context/ViewsContext";
import { Provider as CampaignsContextProvider } from "./context/CampaignsContext";
import { Provider as CompaniesContextProvider } from "./context/CompaniesContext";
import { Provider as ModalContextProvider } from "./context/ModalContext";

import { ModalController, AuthenticatedRoute } from "./HOC";

const App = () => {
  const [{ theme }] = useTheme();

  if (!isMobileOnly) {
    return (
      <PendingComponent
        msg="Jamii solamente funciona en teléfonos móviles."
        emoji="🤭"
      />
    );
  }

  if (!isMobileSafari && !isChrome) {
    return (
      <PendingComponent
        msg="Te recomendamos Safari y Chrome para una mejor experiencia."
        emoji="🤭"
      />
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <ModalContextProvider>
        <CompaniesContextProvider>
          <CampaignsContextProvider>
            <ViewsContextProvider>
              <ModalController />
              <Switch>
                <AuthenticatedRoute exact path="/" component={RootViews} />
                <AuthenticatedRoute path="/login" component={Login} />
                <AuthenticatedRoute
                  path="/password-recovery"
                  component={PasswordRecovery}
                />
                <AuthenticatedRoute
                  path="/password-reset"
                  component={PasswordReset}
                />
                <AuthenticatedRoute
                  path="/companies/:id"
                  component={CompanyProfile}
                />
                <AuthenticatedRoute
                  exact
                  path="/campaigns/:id"
                  component={CampaignDetail}
                />
                <AuthenticatedRoute
                  path="/campaigns/interest/:id"
                  component={CampaignsByInterest}
                />
                <AuthenticatedRoute path="*" component={PageNotFound} />
              </Switch>
            </ViewsContextProvider>
          </CampaignsContextProvider>
        </CompaniesContextProvider>
      </ModalContextProvider>
    </ThemeProvider>
  );
};

export default App;
